(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {
    var allVideos = document.querySelectorAll('.card__hover-video');
    if (!allVideos.length) return;

    var activeVideo = null;

    // Build a list of { card, video, top, bottom } for position matching
    var cardMap = [];
    allVideos.forEach(function (v) {
      var card = v.closest('.card-wrapper') || v.closest('.card');
      if (card) cardMap.push({ card: card, video: v });
    });

    function stopActive() {
      if (!activeVideo) return;
      activeVideo.pause();
      activeVideo.style.opacity = '0';
      activeVideo = null;
    }

    function playVideo(v) {
      if (activeVideo === v) return;
      stopActive();
      if (v.preload === 'none') v.preload = 'auto';
      v.style.opacity = '1';
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
      activeVideo = v;
    }

    /*
     * iOS Safari fix: "unlock" all videos on the first touch.
     * play() from touchstart IS a valid user gesture on iOS.
     * Once a video has been played once, it can be played
     * programmatically from any context.
     */
    var unlocked = false;
    function unlockVideos() {
      if (unlocked) return;
      unlocked = true;
      allVideos.forEach(function (v) {
        var p = v.play();
        if (p && typeof p.then === 'function') {
          p.then(function () { v.pause(); }).catch(function () {});
        }
      });
    }

    /*
     * Find which card the finger is over using bounding rects
     * (more reliable than elementFromPoint on iOS Safari)
     */
    function findCardAtPoint(x, y) {
      for (var i = 0; i < cardMap.length; i++) {
        var rect = cardMap[i].card.getBoundingClientRect();
        if (x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom) {
          return cardMap[i].video;
        }
      }
      return null;
    }

    /* ═══ MOBILE: touch-based hover ═══ */
    document.addEventListener('touchstart', function (e) {
      unlockVideos();
      if (!e.touches.length) return;
      var touch = e.touches[0];
      var video = findCardAtPoint(touch.clientX, touch.clientY);
      if (video) playVideo(video);
      else stopActive();
    }, { passive: true });

    document.addEventListener('touchmove', function (e) {
      if (!e.touches.length) return;
      var touch = e.touches[0];
      var video = findCardAtPoint(touch.clientX, touch.clientY);
      if (video) playVideo(video);
      else stopActive();
    }, { passive: true });

    document.addEventListener('touchend', function () {
      stopActive();
    }, { passive: true });

    document.addEventListener('touchcancel', function () {
      stopActive();
    }, { passive: true });

    /* ═══ DESKTOP: mouseenter / mouseleave ═══ */
    cardMap.forEach(function (item) {
      item.card.addEventListener('mouseenter', function () {
        playVideo(item.video);
      });
      item.card.addEventListener('mouseleave', function () {
        if (activeVideo === item.video) stopActive();
      });
    });

    /* ═══ Pause when tab hidden ═══ */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopActive();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
